module.exports = {
        srcSet: __webpack_public_path__ + "baf759a600c2f379-600.webp"+" 600w"+","+__webpack_public_path__ + "7b66fdce06f30731-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "baf759a600c2f379-600.webp",width: 600,height: 338},{path: __webpack_public_path__ + "7b66fdce06f30731-1000.webp",width: 1000,height: 563}],
        src: __webpack_public_path__ + "7b66fdce06f30731-1000.webp",
        toString: function(){return __webpack_public_path__ + "7b66fdce06f30731-1000.webp"},
        
        width: 1000,
        height: 563
      }